import type { RouteRecordRaw, Router } from 'vue-router'

const CriminalRoutes: RouteRecordRaw = {
  path: '/claim/criminal',
  name: 'CriminalModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'CriminalMainRoute',
      component: () => import('./views/CriminalView.vue'),
      meta: {
        title: 'criminal.criminalClaims',
      },
    },
    {
      path: 'create',
      name: 'CriminalCreateRoute',
      component: () => import('./views/CriminalUpsertView.vue'),
      meta: {
        title: 'criminal.createCriminal',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:criminalId',
      name: 'CriminalEditRoute',
      component: () => import('./views/CriminalUpsertView.vue'),
      meta: {
        title: 'criminal.editCriminal',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:criminalId',
      name: 'ViewCriminalRoute',
      component: () => import('./views/SingleCriminalView.vue'),
      meta: {
        title: 'criminal.ViewCriminal',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(CriminalRoutes)
}
